// Live previews of the admin "Horarios" forms. The server stays the reference:
// these helpers work on naive wall-clock minutes and ignore DST changes.

export const MINUTES_PER_DAY = 24 * 60;
export const NIGHT_START = 22 * 60;
export const NIGHT_END = 6 * 60;

// "2026-10-24T20:00" → minutes since epoch, null when blank.
export function parseDateTime(value) {
  if (!value) return null;
  const [date, time = "00:00"] = value.split("T");
  const [year, month, day] = date.split("-").map(Number);
  const [hours, minutes] = time.split(":").map(Number);
  return Date.UTC(year, month - 1, day, hours, minutes) / 60000;
}

// "19:30" → 1170, null when blank.
export function parseTime(value) {
  if (!value) return null;
  const [hours, minutes] = value.split(":").map(Number);
  return hours * 60 + minutes;
}

// Slot duration; an end before the start finishes the next day.
export function slotMinutes(start, end) {
  return (((end - start) % MINUTES_PER_DAY) + MINUTES_PER_DAY) % MINUTES_PER_DAY;
}

// Overlap with every [D 22:00, D+1 06:00] window, starting the day before.
export function nightMinutes(start, end) {
  let total = 0;
  for (let day = Math.floor(start / MINUTES_PER_DAY) - 1; day * MINUTES_PER_DAY <= end; day++) {
    const windowStart = day * MINUTES_PER_DAY + NIGHT_START;
    const windowEnd = (day + 1) * MINUTES_PER_DAY + NIGHT_END;
    total += Math.max(0, Math.min(end, windowEnd) - Math.max(start, windowStart));
  }
  return total;
}

// 450 → "7,50"
export function formatHours(minutes) {
  return (minutes / 60).toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

// 75 → "+1,25", -30 → "−0,50"
export function formatSignedHours(minutes) {
  if (minutes === 0) return formatHours(0);
  return (minutes > 0 ? "+" : "\u2212") + formatHours(Math.abs(minutes));
}

export function signClass(minutes) {
  if (minutes > 0) return "text-success";
  if (minutes < 0) return "text-danger";
  return "";
}
